import { EMethod } from "../types";
import { API_VERSION } from "../constants";

export const BUSINESS_UNIT_ENDPOINT = {
  USER_ASSOCIATED_BU_LIST: {
    method: EMethod.GET,
    url: "/bu/associated",
    version: API_VERSION.V0,
  },
  GET_BU_INDUSTRIES: {
    method: EMethod.GET,
    url: "/bu/industry",
    version: API_VERSION.V0,
  },
  ADD_BU: {
    method: EMethod.POST,
    url: "/bu",
    version: API_VERSION.V0,
  },
  ADD_ASSIGNMENT_MEMBER: {
    method: EMethod.POST,
    url: "/bu/member/assignment",
    version: API_VERSION.V0,
  },
  CHECK_ASSIGNMENT_MEMBER: {
    method: EMethod.GET,
    url: "/bu/member/assignment/check",
    version: API_VERSION.V0,
  },
  GET_BU_DETAIL: {
    method: EMethod.GET,
    url: "/bu",
    version: API_VERSION.V0,
  },
  UPDATE_BU_PROFILE: {
    method: EMethod.PATCH,
    url: "/bu",
    version: API_VERSION.V0,
  },
  UPDATE_PROFILE_PICTURE: {
    method: EMethod.POST,
    url: "/bu/profile-picture",
    version: API_VERSION.V0,
  },
  GET_EMPLOYEE_ACCESS: {
    method: EMethod.GET,
    url: "/bu/member/employee/access",
    version: API_VERSION.V0,
  },
  UPDATE_EMPLOYEE_ACCESS: {
    method: EMethod.PUT,
    url: "/bu/member/employee/access",
    version: API_VERSION.V0,
  },
  LEAVE_BU: {
    method: EMethod.POST,
    url: "/bu/leave",
    version: API_VERSION.V0,
  },
  GET_BU_STAFF_MEMBER: {
    method: EMethod.GET,
    url: "/bu/member/staff",
    version: API_VERSION.V0,
  },
  GET_BU_UNASSIGNED_MEMBER: {
    method: EMethod.GET,
    url: "/bu/member/unassignment",
    version: API_VERSION.V0,
  },
  GET_BU_STAFF_MEMBER_FILTER: {
    method: EMethod.GET,
    url: "/bu/member/staff/filter",
    version: API_VERSION.V0,
  },
  GET_BU_CLIENT_MEMBER: {
    method: EMethod.GET,
    url: "/bu/member/client",
    version: API_VERSION.V0,
  },
  GET_BU_CORPORATION_MEMBER: {
    method: EMethod.GET,
    url: "/bu/member/corporation",
    version: API_VERSION.V0,
  },
  GET_BU_EMPLOYEE_MEMBER: {
    method: EMethod.GET,
    url: "/bu/member/employee",
    version: API_VERSION.V0,
  },
  REMOVE_BU_MEMBER: {
    method: EMethod.POST,
    url: "/bu/member/remove",
    version: API_VERSION.V0,
  },
  ADD_BU_MEMBER: {
    method: EMethod.POST,
    url: "/bu/member",
    version: API_VERSION.V0,
  },
  DELETE_ASSIGNMENT_MEMBER: {
    method: EMethod.DEL,
    url: "/bu/member/assignment",
    version: API_VERSION.V0,
  },
  DELETE_ASSIGNMENT_ALL: {
    method: EMethod.DEL,
    url: "/bu/member/assignment/all",
    version: API_VERSION.V0,
  },
  ADD_ASSIGNMENT_ALL: {
    method: EMethod.POST,
    url: "/bu/member/assignment/all",
    version: API_VERSION.V0,
  },
  DELETE_BU: {
    method: EMethod.DEL,
    url: "/bu",
    version: API_VERSION.V0,
  },
  GET_BU_GLOBAL: {
    method: EMethod.POST,
    url: "/bu/global/get",
    version: API_VERSION.V0,
  },
  GET_CORP_MEMBER_FILTER: {
    method: EMethod.GET,
    url: "/bu/member/corporation/filter",
    version: API_VERSION.V0,
  },
  GET_INACTIVE_VACANCIES: {
    method: EMethod.POST,
    url: "/bu/job/inactive-vacancies/get",
    version: API_VERSION.V0,
  },
  GET_INACTIVE_VACANCIES_FILTER_DATA: {
    method: EMethod.GET,
    url: "/bu/job/inactive-vacancies/filter",
    version: API_VERSION.V0,
  },
  PUBLISH_JOB: {
    method: EMethod.PUT,
    url: "/bu/job/publish",
    version: API_VERSION.V0,
  },
  GET_HISTORY_ASSOCIATION: {
    method: EMethod.GET,
    url: "/bu/member/history",
    version: API_VERSION.V0,
  },
};
